import { useBaseInput } from '../VBaseInput';
import { joinCn } from '../util';
import twStyle from './style';
import type { VTextareaProps } from './type';

const VInnerTextarea = ({
  ref,
  ...props
}: VTextareaProps & Omit<React.ComponentPropsWithRef<'textarea'>, 'cols'>) => {
  const { textareaClassName, textareaStyle, onBlur, onFocus, ...rest } = props;
  const { id, status, setStatus } = useBaseInput();
  const disabled = status.disabled ?? false;
  const style = twStyle({ ...props } as VTextareaProps);

  return (
    <textarea
      ref={ref}
      id={id}
      className={joinCn(style.input, textareaClassName)}
      style={textareaStyle}
      onBlur={e => {
        setStatus(prev => ({ ...prev, focused: false }));
        onBlur?.(e);
      }}
      onFocus={e => {
        setStatus(prev => ({ ...prev, focused: true }));
        onFocus?.(e);
      }}
      {...rest}
      disabled={disabled}
      onChange={e => {
        setStatus(prev => ({ ...prev, valid: e.target.checkValidity() }));
        rest.onChange?.(e);
      }}
    />
  );
};

export default VInnerTextarea;
